import { DateTime } from 'luxon'

export const USER_FORMAT = 'DD'
export const USER_FULL_FORMAT = 'ff'

export function getDateUserFormat(date) {
  return DateTime.fromISO(date).toFormat(USER_FORMAT)
}

export function isInLast24h(date) {
  return DateTime.fromISO(date) > DateTime.now().minus({ day: 1 })
}

export function getDateUserFullFormat(date) {
  return DateTime.fromISO(date).toFormat(USER_FULL_FORMAT)
}

export function getDateToFormat({ date, format }) {
  return DateTime.fromISO(date).toFormat(format)
}

export function getDateFromTimestampUserFormat(timestamp) {
  return DateTime.fromMillis(timestamp * 1000).toFormat(USER_FORMAT)
}
